import "@velocity/styling/themes/ayvens/theme.css";
import AyvensTheme from "@velocity/styling/themes/ayvens/theme";
import './styles/base.css';
import './styles/desktop.css';
import './styles/mobile.css';
import './styles/tablet.css';
import './styles/print.css';
import React from "react";
import ReactDOM from "react-dom/client";
import { VelocityProvider } from "@velocity/ui";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <VelocityProvider theme={AyvensTheme}>
      <App />
    </VelocityProvider>
  </React.StrictMode>
);
